/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshInstrumentSyncEntities} from '../api'

export const useMutationRefreshInstrumentSyncEntities = createReactQueryMutationHook('refreshInstrumentSyncEntities', refreshInstrumentSyncEntities)
